const contractsSearchPropNameList = [
  'name', 'tags', 'contractNo', 'agentName'
];
export default contractsSearchPropNameList;